"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OVERFLOW_ID_PREFIX = exports.AvatarGroupProvider = exports.AvatarGroupContext = void 0;
var _react = _interopRequireWildcard(require("react"));
const OVERFLOW_ID_PREFIX = "overflow-";
exports.OVERFLOW_ID_PREFIX = OVERFLOW_ID_PREFIX;
const AvatarGroupContext = /*#__PURE__*/(0, _react.createContext)({
  userState: [],
  setSpecificUserToOpen: () => {},
  closeAll: () => {}
});
exports.AvatarGroupContext = AvatarGroupContext;
const AvatarGroupProvider = _ref => {
  let {
    children,
    thisGroupId,
    visibleUsers,
    overflowUsers
  } = _ref;
  const initialUserState = (0, _react.useMemo)(() => {
    const visUsers = visibleUsers.map(user => {
      return {
        isOpen: false,
        id: `${user.email}-${thisGroupId}`
      };
    });
    if (overflowUsers.length > 0) {
      visUsers.push({
        isOpen: false,
        id: `${OVERFLOW_ID_PREFIX}${thisGroupId}`
      });
    }
    return visUsers;
  }, [visibleUsers, thisGroupId, overflowUsers.length]);
  const [userState, setUserState] = (0, _react.useState)(initialUserState);
  const setSpecificUserToOpen = userId => {
    setUserState(prev => {
      return prev.map(prevUser => {
        return {
          ...prevUser,
          isOpen: prevUser.id === userId ? true : false
        };
      });
    });
  };
  const closeAll = () => {
    setUserState(initialUserState);
  };
  return /*#__PURE__*/_react.default.createElement(AvatarGroupContext.Provider, {
    value: {
      userState,
      setSpecificUserToOpen,
      closeAll
    }
  }, children);
};
exports.AvatarGroupProvider = AvatarGroupProvider;
//# sourceMappingURL=AvatarGroupProvider.js.map